import { SETUP_DOCS_URL } from "../../constants.js"
import { renderPanel, type Tone } from "../../ui.js"

function templateReadyLineTone(line: string, _lineIndex: number): Tone {
  if (line === "Next steps:") {
    return "bold"
  }

  if (/^\d+\.\s/.test(line.trimStart())) {
    return "none"
  }

  return "none"
}

export function renderTemplateReady(templateDestinationPath: string): string {
  return renderPanel(
    "Container is created",
    [
      `📂 Location: ${templateDestinationPath}`,
      `📘 Docs: ${SETUP_DOCS_URL}`,
      "",
      "Next steps:",
      "1. Set up your design system dependencies (private or public).",
      "2. Configure private registry access (necessary for local install).",
      "3. Verify the container before upload.",
      "4. Upload the container to Supernova.",
    ],
    { lineTone: templateReadyLineTone },
  )
}
